/* Tecidos Minimal — sections/tecidos-minimal-verao.liquid (cópia de tecidos-minimal.js usada só pelo modelo page.tecidos-verao)
   Delegação de eventos no document: funciona mesmo se a seção for re-renderizada
   pelo editor de temas (sem <script> inline). */
(function () {
  if (window.__tecidosMinimal) return;
  window.__tecidosMinimal = true;

  function selectFabric(root, slug, scroll) {
    var panel = root.querySelector('[data-tm-panel="' + slug + '"]');
    if (!panel) return false;
    root.querySelectorAll('[data-tm-panel]').forEach(function (p) { p.hidden = p !== panel; });
    root.querySelectorAll('[data-tm-tab]').forEach(function (t) {
      var on = t.getAttribute('data-tm-tab') === slug;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on && scroll) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
    var carousel = panel.querySelector('[data-tm-carousel]');
    if (carousel) goTo(carousel, 0);
    return true;
  }

  function goTo(carousel, index) {
    var slides = carousel.querySelectorAll('[data-tm-slide]');
    if (!slides.length) return;
    index = Math.max(0, Math.min(index, slides.length - 1));
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    carousel.setAttribute('data-tm-index', index);
    var prev = carousel.querySelector('[data-tm-prev]');
    var next = carousel.querySelector('[data-tm-next]');
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === slides.length - 1;
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-tm-tab]');
    if (tab) {
      var root = tab.closest('[data-tm]');
      var slug = tab.getAttribute('data-tm-tab');
      if (root && selectFabric(root, slug, true) && history.replaceState) {
        history.replaceState(null, '', '#' + slug);
      }
      return;
    }
    var arrow = e.target.closest('[data-tm-prev], [data-tm-next]');
    if (arrow) {
      var carousel = arrow.closest('[data-tm-carousel]');
      var current = parseInt(carousel.getAttribute('data-tm-index') || '0', 10);
      goTo(carousel, current + (arrow.hasAttribute('data-tm-next') ? 1 : -1));
    }
  });

  /* Setas do teclado entre os tecidos (padrão de tabs acessíveis) */
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-tm-tab]');
    if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    var tabs = Array.prototype.slice.call(tab.closest('[data-tm]').querySelectorAll('[data-tm-tab]'));
    var i = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
    if (i < 0 || i >= tabs.length) return;
    e.preventDefault();
    tabs[i].focus();
    tabs[i].click();
  });

  /* Link direto: /pages/tecidos#linho abre o tecido Linho */
  function fromHash() {
    var slug = decodeURIComponent((location.hash || '').slice(1));
    if (!slug) return;
    document.querySelectorAll('[data-tm]').forEach(function (root) {
      if (selectFabric(root, slug, true)) {
        var selector = root.querySelector('.tm-selector');
        if (!document.querySelector('.tc')) {
          // Páginas existentes (modelo "tecidos", quiz): comportamento original.
          selector.scrollIntoView({ block: 'start' });
          return;
        }
        /* Modelo com a seção tecidos-calor: rola a página depois do scroll suave do
           carrossel de abas (iniciado em selectFabric), que cancelava o scroll vertical
           se feito no mesmo tick. */
        setTimeout(function () {
          window.scrollTo({ top: selector.getBoundingClientRect().top + window.pageYOffset - 80 });
        }, 50);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fromHash);
  else fromHash();
  window.addEventListener('hashchange', fromHash);

  /* ============================================================
     Card de produto (snippets/tecidos-card.liquid): cor + tamanho,
     tabela de medidas (Sizebay) e adicionar ao carrinho.
     Mesma lógica da vitrine compre-3-leve-4 (assets/compre-3-leve-4.js).
     Fail-safe: card com JSON inválido fica como link para a PDP.
     ============================================================ */
  var COLOR_RE = /^cor$|^color$/i;
  var SIZE_RE = /tamanho|size/i;
  var PIX = 0, PARCELAS = 1;
  function brl(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var STORE_SWATCHES = {};

  function Card(el) {
    this.el = el;
    this.p = JSON.parse(el.querySelector('[data-tm-product]').textContent);
    this.opts = el.querySelector('[data-tm-opts]');
    this.msg = el.querySelector('[data-tm-msg]');
    this.btn = el.querySelector('[data-tm-add]');
    this.btnLabel = this.btn.textContent.trim();
    this.priceEl = el.querySelector('[data-tm-price]');
    this.img = el.querySelector('.tm-card__img');
    this.chartBtn = el.querySelector('[data-tm-chart]');
    var names = this.p.options || [];
    this.colorIdx = names.findIndex(function (n) { return COLOR_RE.test(n); });
    this.sizeIdx = names.findIndex(function (n) { return SIZE_RE.test(n); });
    // Pré-seleciona a 1ª variante disponível, MENOS o tamanho: o cliente escolhe.
    var first = this.p.variants.find(function (v) { return v.available; }) || this.p.variants[0];
    this.sel = first ? first.options.slice() : [];
    if (this.sizeIdx >= 0 && this.values(this.sizeIdx).length > 1) this.sel[this.sizeIdx] = null;
    this.btn.setAttribute('role', 'button');
    // A 1ª cor com estoque pode não ser a da foto principal: mostra a foto da cor selecionada.
    var startImg = this.colorIdx >= 0 && this.imageFor(this.sel[this.colorIdx]);
    var base = function (u) { return String(u || '').split('?')[0].split('/').pop(); };
    if (this.img && startImg && base(startImg) !== base(this.img.getAttribute('src'))) {
      this.img.removeAttribute('srcset');
      this.img.src = startImg;
    }
    // Seletor de quantidade (snippet com quantidade: '1,2,3'): estado das N peças.
    this.qsEl = el.querySelector('[data-tm-qs]');
    if (this.qsEl) {
      this.qs = { n: 1, pecas: [], atual: 0, tiers: JSON.parse(this.qsEl.getAttribute('data-tm-qs-tiers') || '{}') };
    }
    this.render();
    this.initChart();
  }
  Card.prototype.values = function (i) {
    var seen = {}, out = [];
    this.p.variants.forEach(function (v) {
      var val = v.options[i];
      if (!(val in seen)) { seen[val] = true; out.push(val); }
    });
    return out;
  };
  // Um valor tem estoque se existe variante disponível com ele + as OUTRAS opções escolhidas.
  Card.prototype.available = function (i, val) {
    var sel = this.sel;
    return this.p.variants.some(function (v) {
      if (!v.available || v.options[i] !== val) return false;
      return sel.every(function (s, j) { return j === i || s == null || v.options[j] === s; });
    });
  };
  Card.prototype.variant = function () {
    var sel = this.sel;
    if (sel.some(function (s) { return s == null; })) return null;
    return this.p.variants.find(function (v) {
      return sel.every(function (s, j) { return v.options[j] === s; });
    }) || null;
  };
  Card.prototype.imageFor = function (color) {
    var ci = this.colorIdx;
    var v = this.p.variants.find(function (x) { return x.options[ci] === color && x.featured_image; });
    return v ? v.featured_image : '';
  };
  Card.prototype.render = function () {
    var self = this;
    this.opts.innerHTML = (this.p.options || []).map(function (name, i) {
      var vals = self.values(i);
      if (vals.length <= 1) return '';
      var isColor = i === self.colorIdx;
      var btns = vals.map(function (val) {
        var ok = self.available(i, val);
        var on = self.sel[i] === val;
        var cls = (isColor ? 'tm-sw' : 'tm-opt') + (on ? ' is-on' : '') + (ok ? '' : ' is-out');
        var style = '';
        if (isColor) {
          var hex = (self.p.swatches || {})[val] || STORE_SWATCHES[val];
          var img = self.imageFor(val);
          style = hex ? ' style="--sw:' + esc(hex) + '"' : (img ? ' style="--sw-img:url(\'' + esc(img) + '\')"' : '');
        }
        return '<button type="button" class="' + cls + '"' + style + ' data-i="' + i + '" data-v="' + esc(val) +
          '" aria-pressed="' + on + '" title="' + esc(val) + '" aria-label="' + esc(name + ': ' + val + (ok ? '' : ' (esgotado)')) + '">' +
          (isColor ? '' : esc(val)) + '</button>';
      }).join('');
      var label = isColor
        ? '<span class="tm-card__rowname">' + esc(name) + ': <b>' + esc(self.sel[i] || '') + '</b></span>'
        : '<span class="tm-card__rowname">' + esc(name) + '</span>';
      return '<div class="tm-card__row' + (isColor ? ' tm-card__row--color' : '') + '" role="group" aria-label="' + esc(name) + '">' +
        label + '<div class="tm-card__btns">' + btns + '</div></div>';
    }).join('');
    this.update();
  };
  Card.prototype.update = function () {
    var v = this.variant();
    var ci = this.colorIdx, cor = this.sel[ci];
    var ref = v || this.p.variants.find(function (x) { return ci < 0 || x.options[ci] === cor; });
    if (ref && this.priceEl) {
      var cmp = ref.compare_at_price > ref.price ? '<s class="tm-price__cmp">' + brl(ref.compare_at_price) + '</s>' : '';
      var pix = Math.round(ref.price * (100 - PIX) / 100);
      var inst = PARCELAS > 1 ? '<span class="tm-price__inst">ou ' + PARCELAS + 'x de ' + brl(Math.floor(ref.price / PARCELAS)) + ' sem juros</span>' : '';
      this.priceEl.innerHTML = cmp + '<span class="tm-price__pix"><b>' + brl(pix) + '</b> no pix</span>' + inst;
    }
    this.msg.textContent = '';
    this.btn.classList.remove('is-added');
    var temNaCor = this.p.variants.some(function (x) { return x.available && (ci < 0 || cor == null || x.options[ci] === cor); });
    var out = (v && !v.available) || !temNaCor;
    this.btn.classList.toggle('is-disabled', out);
    this.btn.setAttribute('aria-disabled', out ? 'true' : 'false');
    this.btn.textContent = out ? 'Esgotado' : this.btnLabel;
    if (this.qs) this.renderQs(ref);
  };

  /* ---------- seletor de quantidade: peça por peça ----------
     Igual à PDP unitária (branch feature/pdp-unidade-avulsa-visivel, assets/pdp-qs-pecas.js):
     com N > 1, a faixa "Peça X de N" fica acima de cor/tamanho; clicar no tamanho registra
     a peça e passa para a próxima (a cor fica, o tamanho solta). Os chips editam uma peça.
     O botão manda as N peças avulsas num add só. O desconto real vem da faixa por
     quantidade do carrinho; aqui só a estimativa (data-tm-qs-tiers). */
  Card.prototype.tierPct = function (n) {
    var t = this.qs.tiers, best = 0;
    Object.keys(t).forEach(function (k) { if (n >= +k && t[k] > best) best = t[k]; });
    return best;
  };
  Card.prototype.qsFaltando = function () {
    var out = [];
    for (var k = 0; k < this.qs.n; k++) if (!this.qs.pecas[k]) out.push(k);
    return out;
  };
  Card.prototype.renderQs = function (ref) {
    var self = this, q = this.qs, n = q.n;
    var base = (ref || this.p.variants[0] || { price: 0 }).price;
    this.qsEl.querySelector('[data-tm-qs-label]').textContent = n > 1 ? n + ' peças' : '1 unidade';
    [].forEach.call(this.qsEl.querySelectorAll('[data-tm-qs-qty]'), function (b) {
      var bn = +b.getAttribute('data-tm-qs-qty'), on = bn === n, pct = self.tierPct(bn);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var un = Math.round(base * (100 - pct) / 100 * (100 - PIX) / 100);
      var sub = b.querySelector('[data-tm-qs-un]');
      if (sub) sub.innerHTML = brl(un) + '/un' + (pct ? ' · <em>' + pct + '% OFF</em>' : '');
    });
    var steps = this.qsEl.querySelector('[data-tm-qs-steps]');
    this.el.classList.toggle('tm-card--multi', n > 1);
    if (n <= 1) { steps.hidden = true; steps.innerHTML = ''; return; }
    var faltando = this.qsFaltando(), completo = !faltando.length;
    if (!completo && faltando.indexOf(q.atual) < 0) q.atual = faltando[0];
    // Total: peças escolhidas + a variante de referência (cor atual) nas que faltam.
    var total = 0;
    for (var t = 0; t < n; t++) total += (q.pecas[t] || ref || this.p.variants[0]).price;
    var pct = this.tierPct(n);
    var pix = Math.round(total * (100 - pct) / 100 * (100 - PIX) / 100);
    var chips = '';
    for (var c = 0; c < n; c++) {
      var v = q.pecas[c], ativo = !completo && c === q.atual;
      chips += '<button type="button" class="tm-qs__chip' + (v ? ' is-done' : '') + (ativo ? ' is-active' : '') +
        '" data-tm-qs-edit="' + c + '">Peça ' + (c + 1) + ': ' + (v ? esc(v.options.join(' · ')) + ' ✓' : (ativo ? 'escolhendo…' : '—')) + '</button>';
    }
    steps.hidden = false;
    steps.innerHTML =
      '<p class="tm-qs__steps-title">' + (completo
        ? 'Pronto! Suas ' + n + ' peças estão escolhidas'
        : 'Peça ' + (q.atual + 1) + ' de ' + n + ': selecione a cor e o tamanho') + '</p>' +
      '<p class="tm-qs__steps-price">' + brl(pix) + ' no pix' + (pct ? ' <span class="tm-qs__off">' + pct + '% OFF levando ' + n + '</span>' : '') + '</p>' +
      '<div class="tm-qs__chips">' + chips + '</div>';
    if (!this.busy && !this.btn.classList.contains('is-disabled')) {
      this.btn.textContent = completo
        ? (this.el.hasAttribute('data-tm-checkout') ? 'Comprar ' + n + ' peças' : 'Adicionar ' + n + ' peças ao carrinho')
        : 'Escolha a peça ' + (q.atual + 1);
    }
  };
  Card.prototype.setQty = function (n) {
    var q = this.qs;
    q.n = n;
    q.pecas.length = Math.min(q.pecas.length, n);
    q.atual = 0;
    for (var k = 0; k < n; k++) if (!q.pecas[k]) { q.atual = k; break; }
    this.update();
  };
  Card.prototype.editPeca = function (k) {
    var q = this.qs, v = q.pecas[k];
    q.atual = k;
    q.pecas[k] = null;
    // Volta a cor da peça editada para o cliente só trocar o que quiser.
    if (v && this.colorIdx >= 0) this.pick(this.colorIdx, v.options[this.colorIdx]);
    else this.update();
  };
  Card.prototype.pick = function (i, val) {
    var self = this;
    this.sel[i] = val;
    if (i === this.colorIdx) {
      // ao trocar de cor, solta o tamanho se ele não existe na cor nova
      this.sel.forEach(function (s, j) {
        if (j !== i && s != null && !self.available(j, s)) {
          self.sel[j] = j === self.sizeIdx ? null : self.values(j).find(function (x) { return self.available(j, x); }) || s;
        }
      });
      var img = this.imageFor(val);
      if (this.img && img) {
        this.img.removeAttribute('srcset');
        this.img.src = img;
      }
    }
    if (this.qs && this.qs.n > 1 && i === this.sizeIdx) {
      var v = this.variant();
      if (v && v.available) {
        var q = this.qs;
        q.pecas[q.atual] = v;
        var prox = this.qsFaltando();
        if (prox.length) q.atual = prox[0];
        this.sel[i] = null; // próxima peça: mesma cor, tamanho em aberto
      }
    }
    this.render();
  };
  Card.prototype.add = function () {
    var self = this;
    if (this.btn.classList.contains('is-disabled') || this.busy) return;
    if (this.qs && this.qs.n > 1) return this.addPecas();
    var missing = (this.p.options || []).filter(function (n, i) { return self.sel[i] == null; });
    if (missing.length) {
      this.msg.textContent = 'Escolha o ' + missing[0].toLowerCase();
      this.el.classList.add('tm-card--shake');
      setTimeout(function () { self.el.classList.remove('tm-card--shake'); }, 400);
      return;
    }
    var v = this.variant();
    if (!v || !v.available) return;
    this.busy = true;
    this.btn.textContent = 'Adicionando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: v.id, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        // Card de "Comprar agora" (data-tm-checkout): vai direto para o checkout.
        if (self.el.hasAttribute('data-tm-checkout')) {
          self.btn.textContent = 'Indo para o checkout…';
          window.location.href = '/checkout';
          return;
        }
        self.busy = false;
        self.btn.classList.add('is-added');
        self.btn.textContent = '✓ Adicionado';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        openCart(data);
        setTimeout(function () { self.update(); }, 1800);
      })
      .catch(function (err) {
        self.busy = false;
        self.btn.textContent = self.btnLabel;
        self.msg.textContent = (err && err.description) || 'Não foi possível adicionar. Tente de novo.';
      });
  };

  Card.prototype.addPecas = function () {
    var self = this, q = this.qs;
    if (this.busy) return;
    var faltando = this.qsFaltando();
    if (faltando.length) {
      q.atual = faltando[0];
      this.update();
      this.msg.textContent = 'Escolha a cor e o tamanho da peça ' + (q.atual + 1) + '.';
      this.el.classList.add('tm-card--shake');
      setTimeout(function () { self.el.classList.remove('tm-card--shake'); }, 400);
      return;
    }
    var counts = {}, order = [];
    q.pecas.forEach(function (v) {
      if (!(v.id in counts)) { counts[v.id] = 0; order.push(v.id); }
      counts[v.id]++;
    });
    this.busy = true;
    this.btn.textContent = 'Adicionando…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: order.map(function (id) { return { id: id, quantity: counts[id] }; }),
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (data) {
        if (self.el.hasAttribute('data-tm-checkout')) {
          self.btn.textContent = 'Indo para o checkout…';
          window.location.href = '/checkout';
          return;
        }
        self.busy = false;
        self.btn.classList.add('is-added');
        self.btn.textContent = '✓ Adicionado';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        openCart(data);
        setTimeout(function () { self.update(); }, 1800);
      })
      .catch(function (err) {
        self.busy = false;
        self.update();
        self.msg.textContent = (err && err.description) || 'Não foi possível adicionar. Tente de novo.';
      });
  };

  // Abre o carrinho lateral com o item novo (mesmo fluxo do botão da PDP: renderContents).
  // Se o tema não tiver a gaveta, atualiza o ícone e mantém o "✓ Adicionado".
  function openCart(data) {
    var drawer = document.querySelector('cart-drawer');
    try {
      if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
        drawer.renderContents(data);
        return;
      }
    } catch (e) { /* cai no fallback */ }
    try {
      var html = data && data.sections && data.sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      var src = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (bubble && src) bubble.innerHTML = src.innerHTML;
    } catch (e) { /* o add já foi feito */ }
  }

  /* ---------- tabela de medidas (Sizebay) ---------- */
  // Mesmas chamadas da vitrine compre-3-leve-4 / PDP: sessão, id do produto na Sizebay pelo id
  // da Shopify e a tabela num iframe. Produto sem medidas na Sizebay → o botão não aparece.
  var SZB = 'https://vfr-v3-production.sizebay.technology';
  var szbSid = null, szbIds = {};
  function szbSession() {
    if (!szbSid) szbSid = fetch(SZB + '/api/me/session-id').then(function (r) { return r.text(); }).then(function (t) { return t.replace(/"/g, '').trim(); });
    return szbSid;
  }
  function szbProductId(pid) {
    if (!szbIds[pid]) {
      szbIds[pid] = szbSession().then(function (sid) {
        return fetch(SZB + '/plugin/my-product-id?sid=' + encodeURIComponent(sid) + '&permalink=' + encodeURIComponent('https://minimalclub.com.br/' + pid))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) { return d && d.id && !d.accessory ? { id: d.id, sid: sid } : null; });
      }).catch(function () { return null; });
    }
    return szbIds[pid];
  }
  // mode 'vfr' = Provador Virtual; senão Tabela de Medidas. Mesmas URLs que o script da Sizebay
  // abre na PDP (copiado de assets/compre-3-leve-4.js).
  function openSizeTable(info, sizes, mode) {
    var enc = '';
    try { enc = btoa(unescape(encodeURIComponent(JSON.stringify(sizes)))); } catch (e) { /* sem tamanhos */ }
    var q = 'id=' + encodeURIComponent(info.id) + '&sid=' + encodeURIComponent(info.sid) + '&lang=br&tenantId=1269&sizes=' + enc;
    var url = mode === 'vfr'
      ? SZB + '/V4/?mode=vfr&' + q + '&backdropWidth=' + window.innerWidth + '&backdropHeight=' + window.innerHeight + '&isMeasurementsTableEnabled=true'
      : 'https://measurements-table.sizebay.technology/?' + q + '&pageProductImg=false&hasRecommendation=&device=false';
    var ov = document.createElement('div');
    // O provador precisa da tela inteira (é assim na PDP).
    ov.className = 'tm-szb' + (mode === 'vfr' ? ' tm-szb--full' : '');
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'Tabela de medidas');
    // A tabela da Sizebay tem o próprio X (avisa por postMessage "close"); fora dela, clique no fundo ou Esc.
    ov.innerHTML = '<div class="tm-szb__box"><iframe class="tm-szb__frame" title="Tabela de medidas" src="' + esc(url) + '"></iframe></div>';
    var close = function () {
      ov.remove();
      document.removeEventListener('keydown', onKey, true);
      window.removeEventListener('message', onMsg);
    };
    var onKey = function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } };
    var onMsg = function (e) {
      if (/sizebay\.technology$/.test(e.origin) && String(e.data).indexOf('close') >= 0) close();
    };
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    document.addEventListener('keydown', onKey, true);
    window.addEventListener('message', onMsg);
    document.body.appendChild(ov);
  }
  Card.prototype.pid = function () {
    var ci = this.colorIdx, cor = this.sel[ci];
    var v = this.p.variants.find(function (x) { return x.pid && (ci < 0 || x.options[ci] === cor); }) || this.p.variants[0];
    return v && v.pid;
  };
  // Card com data-tm-sizehelp: em vez do link "Tabela de medidas", o mesmo bloco da PDP
  // (snippets/mc-size-help.liquid): "Ficou com dúvidas…" + "Guia de medidas" → Provador
  // Virtual / Tabela de Medidas. Só aparece se o produto tiver medidas na Sizebay.
  var SZH_HTML = '<p class="tm-szh__q"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 3.7 2.2c-.8.5-1.2 1-1.2 2"/><circle cx="12" cy="16.5" r=".6" fill="#121212" stroke="none"/></svg>Ficou com dúvidas sobre o seu tamanho?</p>' +
    '<button type="button" class="tm-szh__btn" data-tm-szh-toggle aria-expanded="false"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="8" width="18" height="8" rx="1"/><path d="M7 8v3M11 8v2M15 8v3M19 8v2"/></svg>Guia de medidas</button>' +
    '<div class="tm-szh__panel" data-tm-szh-panel hidden>' +
      '<button type="button" class="tm-szh__row" data-tm-szb="vfr"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="1.5" aria-hidden="true"><circle cx="12" cy="7" r="3"/><path d="M6 21v-2a6 6 0 0 1 12 0v2"/></svg><span><strong>Provador Virtual</strong><small>Insira informações básicas para simulação</small></span></button>' +
      '<button type="button" class="tm-szh__row tm-szh__row--accent" data-tm-szb="chart"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M8 4 4 7l2 3 2-1v11h8V9l2 1 2-3-4-3-2 2h-2z"/></svg><span><strong>Tabela de Medidas</strong><small>Veja a tabela completa por tamanho</small></span></button>' +
    '</div>';
  Card.prototype.initChart = function () {
    var self = this, pid = this.pid();
    if (!this.chartBtn || !pid) return;
    var target = this.chartBtn;
    if (this.el.hasAttribute('data-tm-sizehelp')) {
      this.szh = document.createElement('div');
      this.szh.className = 'tm-szh';
      this.szh.hidden = true;
      this.szh.innerHTML = SZH_HTML;
      this.chartBtn.parentNode.insertBefore(this.szh, this.chartBtn);
      target = this.szh;
    }
    szbProductId(pid).then(function (info) { if (info && target.isConnected) target.hidden = false; });
  };
  Card.prototype.openChart = function (mode) {
    var self = this, first = this.p.variants[0] && this.p.variants[0].pid;
    var sizes = this.sizeIdx >= 0 ? this.values(this.sizeIdx) : [];
    szbProductId(this.pid() || first).then(function (info) {
      return info || szbProductId(first);
    }).then(function (info) { if (info) openSizeTable(info, sizes, mode); else window.location.href = self.btn.getAttribute('href'); });
  };

  var cards = new WeakMap();
  function initCards() {
    // Pode haver mais de um root na página (ex.: tecidos-calor + tecidos-minimal).
    var root = document.querySelector('[data-tm]');
    if (!root) return;
    PIX = parseFloat(root.getAttribute('data-tm-pix')) || 0;
    PARCELAS = parseInt(root.getAttribute('data-tm-parcelas'), 10) || 1;
    var els = document.querySelectorAll('[data-tm] [data-tm-card]');
    [].forEach.call(els, function (el) {
      try {
        var sw = JSON.parse(el.querySelector('[data-tm-product]').textContent).swatches || {};
        Object.keys(sw).forEach(function (k) { if (sw[k] && !STORE_SWATCHES[k]) STORE_SWATCHES[k] = sw[k]; });
      } catch (e) { /* card inválido */ }
    });
    [].forEach.call(els, function (el) {
      if (cards.has(el)) return;
      try { cards.set(el, new Card(el)); el.classList.add('is-ready'); } catch (e) { /* fica o link pra PDP */ }
    });
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-tm-card]');
    var card = el && cards.get(el);
    if (!card) return;
    var opt = e.target.closest('[data-i]');
    if (opt && card.opts.contains(opt)) {
      if (opt.classList.contains('is-out') && parseInt(opt.getAttribute('data-i'), 10) !== card.colorIdx) return;
      card.pick(parseInt(opt.getAttribute('data-i'), 10), opt.getAttribute('data-v'));
      return;
    }
    var qsBtn = e.target.closest('[data-tm-qs-qty]');
    if (qsBtn && card.qs) { card.setQty(+qsBtn.getAttribute('data-tm-qs-qty') || 1); return; }
    var qsEdit = e.target.closest('[data-tm-qs-edit]');
    if (qsEdit && card.qs) { card.editPeca(+qsEdit.getAttribute('data-tm-qs-edit')); return; }
    if (e.target.closest('[data-tm-chart]')) { card.openChart(); return; }
    var szhToggle = e.target.closest('[data-tm-szh-toggle]');
    if (szhToggle) {
      var panel = card.szh.querySelector('[data-tm-szh-panel]');
      panel.hidden = !panel.hidden;
      szhToggle.setAttribute('aria-expanded', String(!panel.hidden));
      return;
    }
    var szbRow = e.target.closest('[data-tm-szb]');
    if (szbRow) { card.openChart(szbRow.getAttribute('data-tm-szb')); return; }
    if (e.target.closest('[data-tm-add]')) { e.preventDefault(); card.add(); }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCards);
  else initCards();
  document.addEventListener('shopify:section:load', initCards);

  // Volta do bfcache (cliente voltou do checkout pelo "Comprar agora"): a página volta
  // congelada com o card em "Indo para o checkout…" e travado (busy). Destrava.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    [].forEach.call(document.querySelectorAll('[data-tm] [data-tm-card]'), function (el) {
      var card = cards.get(el);
      if (!card || !card.busy) return;
      card.busy = false;
      card.update();
    });
  });
})();
